import { getImageAttributes } from '@notino/react-web-utils';
import { GetCatalogProductViewQuery } from '@notino/shared/definitions/types';

export const getImagesAttributes = (
  images: GetCatalogProductViewQuery['productDetailByCatalogMasterId']['variants'][number]['media']['mainImage'][],
  domain: string,
  sourceKey: string
) => images.map((image) => getImageAttributes(image, domain, sourceKey));
